// Copyright (c) 2016 Deere & Company

import * as fetchService from '../../../shared/services/fetch';
import {handleError} from '../../../shared/services/error-handlers';

const basePath = '/api';

export async function readCustomers() {

    const endPoint = `${basePath}/customers`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function readCustomer(id, customerPrivate) {

    const endPoint = customerPrivate ?
        `${basePath}/customers/${id}?customerPrivate=${customerPrivate}` :
        `${basePath}/customers/${id}`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function createCustomer(ckcId) {

    const endPoint = `${basePath}/customers`;

    try {

        const response = await fetchService.fetch(endPoint, {
            body: JSON.stringify({
                ckcId
            }),
            method: 'POST'
        });

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function updateCustomer(customerId) {

    const endPoint = `${basePath}/customers/${customerId}`;

    try {

        const response = await fetchService.fetch(endPoint, {
            method: 'PUT'
        });

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}



// WEBPACK FOOTER //
// ./src/customer/shared/repositories/index.js